import { tick } from 'svelte';

let animElements: Array<any> = []

export async function animRoutChange() {
	loadElements(true)
	handleScroll()

	setTimeout(() => {
		loadElements(false)
		handleScroll()
	}, 100)
}

export function animInit() {
	loadElements(true)
	window.addEventListener('scroll', handleScroll)
	handleScroll()
}

const loadElements = (clear: boolean) => {
	if (clear) {
		animElements = []
	}

	const nodeElements = [
		...document.querySelectorAll('.animated'),
		...document.querySelectorAll('.animated-children'),
	]
	for (const element of nodeElements) {
		element.classList.add('hidden')
		if (!animElements.includes(element)) {
			animElements.push(element)
		}
	}
}

const handleScroll = () => {
	for (const element of animElements) {
		if (
			window.innerHeight * 0.9 > element.getBoundingClientRect().top ||
			(window.scrollY === 0 &&
				window.innerHeight * 1.1 > element.getBoundingClientRect().top)
		) {
			element.classList.remove('hidden')
			element.classList.add('started')
		}
	}
}